<div *ngIf="previewData">
  <h5 class="text-primary fw-semibold mb-1">{{previewData.displayName}}</h5>
  <div>
    <strong>Operating System:&nbsp;</strong> <span class="fw-semibold">{{previewData.os}}</span>
  </div>
  <div>
    <strong>OS Version:&nbsp;</strong> <span class="fw-semibold">{{previewData.osVersion}}</span>
  </div>
  <div>
    <strong>SDKs & Frameworks:&nbsp;</strong> <span class="fw-semibold">{{previewData.sdks}}</span>
  </div>
  <div>
    <strong>Databases:&nbsp;</strong> <span class="fw-semibold">{{previewData.databases}}</span>
  </div>
  <div>
    <strong>Development Tools:&nbsp;</strong> <span class="fw-semibold">{{previewData.editors}}</span>
  </div>
  <div>
    <strong>Miscellaneous:&nbsp;</strong> <span class="fw-semibold">{{previewData.misc}}</span>
  </div>
</div>
